import t from"tailwind-styled-components";import{twString as r}from"../utils.js";const e=t.p`
  mx-auto
  text-base
  text-current
  leading-5

  md:text-lg

  ${({$rainbow:t})=>!0===t&&r`
    bg-clip-text
    bg-gradient-to-br
    from-brand-accent
    to-brand-primary
    [-webkit-text-fill-color:transparent;]
  `}
`;e.defaultProps={$rainbow:!1};export{e as default};
